import cookie from "./cookie";
import lang from "./lang";

// 极验语言
function getGeetestLanguage() {
    const _lang = lang.getLang("_lang");
    const CN_lang = lang.getLang("CN_lang");
    // 简体中文
    if (_lang === "CN" && CN_lang === "zh_CN") {
        return "zho";
    }
    // 台湾（繁）
    if (_lang === "CN" && CN_lang === "zh_TW") {
        return "zho-tw";
    }
    // 英文
    if (_lang === "EN") {
        return "eng";
    }
    // 默认中文
    return "zho";
}

function caseInsensitiveSearch(keyword, targetString) {
    const lowercaseKeyword = keyword && keyword.toLowerCase() || '';
    const lowercaseTargetString = targetString && targetString.toLowerCase() || '';

    return lowercaseTargetString && lowercaseTargetString.includes(lowercaseKeyword);
}

// Select serach 函数: 支持搜索 value 和 option 节点字符串、不区分大小写
function handleSearch(searchValue, value, item) {
    const _searchValue = searchValue && searchValue.trim();
    return (
        caseInsensitiveSearch(_searchValue, value) ||
        caseInsensitiveSearch(_searchValue, item.props.children[0])
    );
}
module.exports = {
    getGeetestLanguage,
    handleSearch
};



// WEBPACK FOOTER //
// src/common/utils.js